import { combineReducers } from 'redux'
import ChatMessageReducer from './chat.message.reducer'
import ChatSocketReducer from './chat.socket.reducer'

const ChatReducer = combineReducers({
  socket: ChatSocketReducer,
  messaging: ChatMessageReducer,
})

export default ChatReducer